// Google Analytics 4. The measurement ID is public (it ships in the page
// source of every GA site), so it lives here rather than in an env file.
const GA_ID = 'G-EXJ71QEQPJ';

// react-scripts sets NODE_ENV to 'development' for `npm start` and
// 'production' for `npm run build`, so local browsing is never tracked.
const ENABLED = process.env.NODE_ENV === 'production';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const initGA = () => {
  if (!ENABLED || window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // gtag.js expects the raw arguments object pushed onto dataLayer.
  const gtag: (...args: unknown[]) => void = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag = gtag;

  gtag('js', new Date());
  // AnalyticsTracker sends page_view on every route change, including the
  // first one, so the automatic one is turned off to avoid double counting.
  gtag('config', GA_ID, { send_page_view: false });
};

export const trackPageView = (path: string) => {
  if (!ENABLED || !window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
